import { EntTerritorialsUnits } from "../handBooks/territorialsUnits";
import { EntCitizenship } from "../citizenship/citizenship";
import { EntProductType } from "./grossProductCollection";
import { EntUnitMeasurement } from "../handBooks/unitMeasurement";

export class EntTradeRegistry {
  id: number|null = null;
  year: number|null = null;
  month: number|null = null;
  tradeType: string|null = null;
  citizenship?: EntCitizenship|null = null;
  productType?: EntProductType|null = null;
  unitOfMeasurement?: EntUnitMeasurement|null = null;
  quantity: number|null = null;
  value: number|null = null;
  regionOfDispatch?: EntTerritorialsUnits|null = null;
  regionOfArrival?: EntTerritorialsUnits|null = null;

  citizenshipId?: number|null = null;
  productTypeId?: number|null = null;
  unitOfMeasurementId?: number|null = null;
  regionOfDispatchId?: number|null = null;
  regionOfArrivalId?: number|null = null;
}
